import React from "react";
import { cn } from "../../lib/utils";

const badgeVariants = {
  default:
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  secondary:
    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  destructive:
    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
  outline: "text-foreground",
};

function Badge({ className, variant = "default", ...props }) {
  return (
    <div
      className={cn(badgeVariants.default, badgeVariants[variant], className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
